export default __webpack_public_path__ + "57ced8e7726df1516c1983a8b71eabf7.png";